"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var BaseClient =
/*#__PURE__*/
function () {
  function BaseClient(_ref) {
    var accessToken = _ref.accessToken,
        channelId = _ref.channelId;
    (0, _classCallCheck2.default)(this, BaseClient);
    this.headers = new Headers({
      Authorization: "Bearer ".concat(accessToken),
      'Content-Type': 'application/json',
      Accept: 'application/json; charset=utf-8'
    });
    this.channelId = channelId;
    this.cancelled = false;
  }
  /**
   * Mark the client as cancelled.
   */


  (0, _createClass2.default)(BaseClient, [{
    key: "cancel",
    value: function cancel() {
      this.cancelled = true;
    }
    /**
     * Return whether this client has been cancelled.
     */

  }, {
    key: "isCancelled",
    value: function isCancelled() {
      return this.cancelled;
    }
  }]);
  return BaseClient;
}();

exports.default = BaseClient;